import React from 'react';
import './style.less';
import { Row, Col } from 'antd';
import TweenOne from 'rc-tween-one';
import QueueAnim from 'rc-queue-anim';
import { OverPack } from 'rc-scroll-anim';
import PxLoader from "./../../../../static/js/PxLoader"
// import "./../../../../static/js/PxLoaderImage"
import PicLoader from './loader'
class AircraftInfo extends React.PureComponent {
    componentDidMount() {
       // this.loadImage()
        this.loader = new PicLoader()
    }

    render() {
    const { ...props } = this.props;
    const { dataSource } = props;
    const arr = [1,2,3,4,5,6];
    delete props.dataSource;
    delete props.isMobile;
      const style = { background: '#0092ff', padding: '8px 0' };
      const colStyle = {marginBottom:48}
      return (
      <div className='aircraft-info-wrapper'>

              <div className="aircraft-info">
                  <div className="sticky">
                      <canvas className="p4-scrolling" width="1200" height="720">

                      </canvas>
                  </div>
                  <div className="description-container">
                      <div className="description">
                          <h3>力动几何P系列纯电动无人机</h3>
                      </div>

                      <div className="description">
                          <h3>所思所想，如虎添翼  </h3>
                      </div>

                      <div className="description">
                          <p>力动几何作为空气动力学技术和尖端工业设计的先驱<br></br>一直致力于制造具有大容量、长续航的优质多功能的垂直起降电动无人机<br></br>我们的产品现已成为许多个人及工业客户的首选。 </p>
                      </div>

                      <div className="description">
                         <div className='line'>
                             <Row>
                                 <Col style={colStyle} xs={12} sm={12} md={12} lg={8} xl={8}>
                                     <img src="http://qiniu.metridynamic.com/image%2Fp4%2FPayload%20interchangable.png" alt={""}/>
                                      <p>多载荷互换</p>
                                 </Col>
                                 <Col style={colStyle} xs={12} sm={12} md={12} lg={8} xl={8}>
                                     <img src="http://qiniu.metridynamic.com/image%2Fp4%2FAll%20electric.png" alt={""}/>
                                      <p>纯电动</p>
                                 </Col>
                                 <Col style={colStyle} xs={12} sm={12} md={12} lg={8} xl={8}>
                                     <img src="http://qiniu.metridynamic.com/image/new-official-en/P4icon/level.png" alt={""}/>
                                      <p>6级抗风性能</p>
                                 </Col>
                                 <Col xs={12} sm={12} md={12} lg={8} xl={8}>
                                     <img src="http://qiniu.metridynamic.com/image/new-official-en/P4icon/distance.png" alt={""}/>
                                      <p>150km最大控制距离</p>
                                 </Col>
                                 <Col xs={12} sm={12} md={12} lg={8} xl={8}>
                                     <img src="http://qiniu.metridynamic.com/image/new-official-en/P4icon/max.png" alt={""}/>
                                      <p>6kg最大载荷</p>
                                 </Col>
                                 <Col xs={12} sm={12} md={12} lg={8} xl={8}>
                                     <img src="http://qiniu.metridynamic.com/image/new-official-en/P4icon/weight.png" alt={""}/>
                                      <p>15kg级最大起飞重量</p>
                                 </Col>
                             </Row>
                         </div>
                      </div>

                      {/*<div className="description">*/}
                      {/*    <h3>Designed to be seen and heard.</h3>*/}
                      {/*    <p>HomePod is wrapped in a seamless mesh fabric designed for aesthetics and acoustic*/}
                      {/*        performance. Available in white and space gray, it’s gorgeous from every angle — yet*/}
                      {/*        virtually transparent to the sound waves passing through it.</p>*/}
                      {/*</div>*/}
                  </div>
              </div>
      </div>
    );
  }
}

export default AircraftInfo;
